
import WebFont from 'webfontloader'

const options = {"google":{"families":["Amaranth","Titillium+Web"]}}

WebFont.load(options)
